import { spawn, call, put, takeLatest } from 'redux-saga/effects';
import { createAction } from '@reduxjs/toolkit';
import { garmentCarActions } from '../../../application/actions/garmentCard';

import api from '../../api/index';

const apiRequest = api(process.env.REACT_APP_HOST);


// GETBYID
export function* getByIdFetch(e) {
    yield put(garmentCarActions.conexionGetById({connection:true}));
    try {
        const  params  = e.payload;
        const url = `garment/car/${params.id}`
        const response = yield call(
            apiRequest.get,
            url,
        );

        // Extraigo todos los datos
        const { data } = response;
        yield put(garmentCarActions.getById({data}));
    } catch (err) {
        yield put(garmentCarActions.errorGetById({error:true, message:err.message}));
    } finally {
        yield put(garmentCarActions.conexionGetById({connection:false}));
    }
}


export function* watchFetchGarmentCar() {
    yield takeLatest(garmentCarActionsSaga.getById.type,  getByIdFetch);
}

export default function* rootSaga() {
    yield spawn(watchFetchGarmentCar);
}



const getById = createAction('garmentCarSaga/getById');

export const garmentCarActionsSaga = {
    getById
};
